import React, { useState } from 'react';
import { ChevronDown, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const NAV_ITEMS = [{
  label: 'Mailboxes',
  href: '/6m8/mailboxes.html',
  dropdown: [{
    label: 'Complete Mailbox & Post Systems',
    href: '/6m8/mailboxes/complete-mailbox-post-system.html'
  }, {
    label: 'Curbside Mailboxes',
    href: '/6m8/mailboxes/curbside-mailboxes.html'
  }, {
    label: 'Wall Mount Mailboxes',
    href: '/6m8/mailboxes/wall-mount-mailboxes.html'
  }, {
    label: 'Locking Mailboxes',
    href: '/6m8/mailboxes/locking-mailboxes.html'
  }, {
    label: 'Stone & Brick Column Mailboxes',
    href: '/6m8/mailboxes/stone-brick-column-mailboxes.html'
  }, {
    label: 'Mailbox Posts',
    href: '/6m8/mailbox-posts.html'
  }]
}, {
  label: 'Commercial',
  href: '/6m8/commercial-mailboxes-lockers.html',
  dropdown: [{
    label: 'Commercial Mailboxes & Lockers',
    href: '/6m8/commercial-mailboxes-lockers.html'
  }, {
    label: 'Centralized Delivery Mailboxes & Kiosks',
    href: '/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-kiosks.html'
  }, {
    label: '4C / CBU Systems',
    href: '/6m8/commercial-mailboxes-lockers/4c-cbu-systems.html'
  }, {
    label: 'Parcel Lockers',
    href: '/6m8/commercial-mailboxes-lockers/parcel-lockers.html'
  }, {
    label: 'Private Delivery Mailboxes',
    href: '/6m8/commercial-mailboxes-lockers/private-delivery-mailboxes.html'
  }, {
    label: 'Collection Boxes',
    href: '/6m8/commercial-mailboxes-lockers/collection-boxes.html'
  }, {
    label: 'Commercial Locks, Hinges & Doors',
    href: '/6m8/commercial-mailboxes-lockers/replacement-commercial-locks-hinges-doors.html'
  }]
}, {
  label: 'Parts & Replacements',
  href: '/6m8/mailboxes/mailbox-replacement-parts.html',
  dropdown: [{
    label: 'Mailbox Replacement Parts',
    href: '/6m8/mailboxes/mailbox-replacement-parts.html'
  }, {
    label: 'Replacement Numbers',
    href: '/6m8/mailboxes/replacement-numbers.html'
  }, {
    label: 'Locks, Keys, Doors & Hinges',
    href: '/6m8/mailboxes/mailbox-replacement-parts.html'
  }, {
    label: 'Posts & Hardware',
    href: '/6m8/mailbox-posts.html'
  }, {
    label: 'Help Identifying a Replacement',
    href: '/ContactUs.html'
  }]
}, {
  label: 'Signs & Address',
  href: '/6m8/address-plaques-and-house-numbers.html',
  dropdown: [{
    label: 'Street Signs & Traffic Signs',
    href: '/6m8/street-signs-traffic-signs.html'
  }, {
    label: 'Decorative Signage',
    href: '/6m8/decorative-signage.html'
  }, {
    label: 'Address Plaques & House Numbers',
    href: '/6m8/address-plaques-and-house-numbers.html'
  }, {
    label: 'Decorative Stop Signs',
    href: '/6m8/decorative-signage.html'
  }, {
    label: 'Sign Frames & Back Plates',
    href: '/6m8/street-signs-traffic-signs.html'
  }]
}, {
  label: 'Lighting & Garden',
  href: '/6m8/lighting.html',
  dropdown: [{
    label: 'Lighting',
    href: '/6m8/lighting.html'
  }, {
    label: 'Outdoor Lamp Posts',
    href: '/6m8/lighting.html'
  }, {
    label: 'Exterior Lighting',
    href: '/6m8/lighting.html'
  }, {
    label: 'Home & Garden Accents',
    href: '/6m8/lighting.html'
  }]
}, {
  label: 'Install Instructions',
  href: '/13.html'
}, {
  label: 'Help Choosing',
  href: '/ContactUs.html',
  highlight: true
}];
export function Navigation() {
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <>
      {/* Mobile Menu Button (Rendered in Header typically, but we'll add a floating one here for simplicity if Header isn't modified to include it. Actually, let's just render the nav bar and assume Header has the button or we add it here for mobile) */}
      <div className="lg:hidden bg-brand-green text-white px-4 py-3 flex justify-between items-center relative z-40" data-id="element-444">
        <span className="font-serif font-bold" data-id="element-445">Menu</span>
        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-1" data-id="element-446">
          {mobileMenuOpen ? <X size={24} data-id="element-447" /> : <Menu size={24} data-id="element-448" />}
        </button>
      </div>

      {/* Mobile Drawer */}
      <AnimatePresence data-id="element-449">
        {mobileMenuOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="lg:hidden bg-brand-green text-white overflow-hidden absolute w-full z-30 shadow-xl" data-id="element-450">
            <ul className="flex flex-col py-2" data-id="element-451">
              {NAV_ITEMS.map(item => <li key={item.label} className="border-b border-white/10 last:border-0" data-id="element-452">
                  <a href={item.href} className={`block px-6 py-4 text-sm font-medium ${item.highlight ? 'text-brand-gold' : ''}`} data-id="element-453">
                    {item.label}
                  </a>
                </li>)}
            </ul>
          </motion.div>}
      </AnimatePresence>

      {/* Desktop Nav */}
      <nav className="hidden lg:block bg-brand-green text-white relative z-30" data-id="element-454">
        <div className="max-w-7xl mx-auto px-4" data-id="element-455">
          <ul className="flex items-center space-x-1" data-id="element-456">
            {NAV_ITEMS.map(item => <li key={item.label} className="relative" onMouseEnter={() => setActiveMenu(item.label)} onMouseLeave={() => setActiveMenu(null)} onFocus={() => setActiveMenu(item.label)} onBlur={() => setActiveMenu(null)} data-id="element-457">
                <a href={item.href} className={`flex items-center gap-1 px-4 py-3.5 text-sm font-medium transition-colors focus:outline-none focus:bg-white/20 ${item.highlight ? 'bg-brand-red hover:bg-brand-red/90' : 'hover:bg-white/10'}`} data-id="element-458">
                  {item.label}
                  {item.dropdown && <ChevronDown size={14} className={`transition-transform ${activeMenu === item.label ? 'rotate-180' : ''}`} data-id="element-459" />}
                </a>

                {/* Mega Menu Dropdown */}
                {item.dropdown && <AnimatePresence data-id="element-460">
                    {activeMenu === item.label && <motion.div initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 10
              }} transition={{
                duration: 0.15
              }} className="absolute top-full left-0 w-72 bg-white text-brand-charcoal shadow-xl border border-brand-border rounded-b-md overflow-hidden" data-id="element-461">
                        <ul className="py-2" data-id="element-462">
                          {item.dropdown.map(subItem => <li key={subItem.label} data-id="element-463">
                              <a href={subItem.href} className="block px-5 py-2.5 text-sm hover:bg-brand-cream hover:text-brand-green transition-colors focus:outline-none focus:bg-brand-cream focus:text-brand-green" data-id="element-464">
                                {subItem.label}
                              </a>
                            </li>)}
                        </ul>
                      </motion.div>}
                  </AnimatePresence>}
              </li>)}
          </ul>
        </div>
      </nav>
    </>;
}